<template>
  <b-modal
    title="Existing User"
    v-model="showModal"
    ok-title="Confirm"
    @ok="submit"
    @cancel="cancel"
    @hide="cancel"
  >
    <p>
      Would you like to add this existing user, <strong>{{user.name}} ({{user.email}})</strong>, to the project?
    </p>
  </b-modal>
</template>
<script>

export default {
  props: {
    user: {type: Object, default: null }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show(){
      this.showModal = true;
    },
    hide(){
      this.showModal = false;
    },
    submit() {
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('cancel');
    },
  }
}

</script>